__turbopack_context__.v({
  "address": "InPersonLocation-module-scss-module__Wf2lXq__address",
  "divider": "InPersonLocation-module-scss-module__Wf2lXq__divider",
  "howToGetThere": "InPersonLocation-module-scss-module__Wf2lXq__howToGetThere",
  "inPersonEventLocation": "InPersonLocation-module-scss-module__Wf2lXq__inPersonEventLocation",
  "map": "InPersonLocation-module-scss-module__Wf2lXq__map",
});
